/**
 * Reconstitue le libellé affiché d'un client à partir de `firstName` et `lastName`.
 *
 * Convention produit :
 * - INDIVIDUAL → "Prénom Nom" (ou seulement le nom si pas de prénom).
 * - INSTITUTION / COMPANY → `lastName` porte la dénomination ; on n'y ajoute pas le prénom
 *   (qui identifie un contact secondaire pour les organisations).
 */
export interface CustomerNameParts {
  firstName?: string | null;
  lastName?: string | null;
  type?: "INDIVIDUAL" | "INSTITUTION" | "COMPANY" | null;
}

export function formatCustomerName(parts: CustomerNameParts | null | undefined): string {
  if (!parts) return "";
  const first = (parts.firstName ?? "").trim();
  const last = (parts.lastName ?? "").trim();
  if (parts.type && parts.type !== "INDIVIDUAL") {
    return last;
  }
  return [first, last].filter(Boolean).join(" ") || last;
}

/** Renvoie les initiales (max 2 lettres) pour un avatar. */
export function getCustomerInitials(parts: CustomerNameParts | null | undefined): string {
  if (!parts) return "?";
  const first = (parts.firstName ?? "").trim();
  const last = (parts.lastName ?? "").trim();
  if (parts.type && parts.type !== "INDIVIDUAL") {
    return last.slice(0, 2).toUpperCase() || "?";
  }
  const letters = [first.charAt(0), last.charAt(0)].filter(Boolean).join("");
  return (letters || last.slice(0, 2)).toUpperCase() || "?";
}
